// Utility to get the correct image URL based on environment
const getImageUrl = (imagePath) => {
  if (!imagePath) return '';
  
  // If it's already a full URL, return as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // Extract filename and determine directory
  let filename = imagePath;
  let directory = 'images'; // default directory
  
  // Remove any leading slashes
  filename = filename.replace(/^\/+/, '');
  
  // Check if path contains directory prefix
  if (filename.startsWith('uploads/')) {
    filename = filename.replace('uploads/', '');
    directory = 'uploads';
  } else if (filename.startsWith('images/')) {
    filename = filename.replace('images/', '');
    directory = 'images';
  }
  
  // Construct the normalized path
  const normalizedPath = `/${directory}/${filename}`;
  
  // Always use relative path - images served from same domain as frontend
  // Production: http://wallofframe.infocareerindia.com/images/filename.jpg
  // Development: http://localhost:3000/images/filename.jpg (proxied to backend)
  return normalizedPath;
};

export default getImageUrl;
